import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.878 12.852a.75.75 0 0 1 .75.75v6.875a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-5a.5.5 0 0 0-.5-.5h-1.25a.5.5 0 0 0-.5.5v5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75v-6.875a.75.75 0 1 1 1.5 0v6.125h3.5v-4.25a2 2 0 0 1 2-2h1.25a2 2 0 0 1 2 2v4.25h3.5v-6.125a.75.75 0 0 1 .75-.75zm-8.288-9.52a2 2 0 0 1 2.828 0l1.719 1.718a.75.75 0 0 1 .616-.322h3.125a.75.75 0 0 1 .75.75v4.064l2.28 2.28a.75.75 0 0 1 .073.977l-.072.084a.75.75 0 0 1-1.061 0l-8.49-8.49a.5.5 0 0 0-.708-.001l-8.491 8.49a.75.75 0 1 1-1.061-1.06zm7.538 2.896h-1.625v.189l1.625 1.625V6.228z' />
  </svg>
);
